export default __webpack_public_path__ + "static/baloon-e5f0f25b53ff7ba55ff10b487013424f.webp";